import React, { useState, useEffect } from 'react';
import { MDBDataTable } from 'mdbreact';
import { each } from 'async';
import { CSVLink } from 'react-csv';

const SalesTableView = ({ salesData, salesSku, salesQuery, height }) => {
	const [currentData, setCurrentData] = useState([]);
	const [rowsData, setRowsData] = useState([]);
	const [rowsDataCsv, setRowsDataCsv] = useState([]);

	const today = new Date();
	const csvDate = `${today.getFullYear()}_${
		today.getMonth() + 1
	}_${today.getDate()}`;

	useEffect(() => {
		if (salesData && salesData.lineData) {
			setRowsData(salesData.lineData);
		}
	}, [salesData]);

	function capitalize(str) {
		const lower = str.toLowerCase();
		return str.charAt(0).toUpperCase() + lower.slice(1);
	}

	// console.log('rowsData', rowsData);
	// console.log('salesSku', salesSku);

	useEffect(() => {
		if (salesSku && salesSku[0] && rowsData) {
			const filterSales = salesSku[0].value; // sales Quantity, Sales
			const filterCategory = salesSku[1].value; // type Brand , Chain
			// console.log('filterSales', filterSales);

			const currentData = filterCategory
				? rowsData[filterCategory]
				: rowsData['Brand'];

			const tableLabels = [];
			const tableHeaders = [];

			tableHeaders.push({
				label: 'Dates',
				field: 'Dates',
			});
			let dates = [];

			if (filterCategory && filterSales) {
				let labels;
				const data = [];
				const allData =
					currentData &&
					currentData[filterSales].map((e, i) => {
						if (e.labels) {
							dates.push(e.labels);
							tableLabels.push({ label: 'Dates', data: e.labels });
						}
						if (e.label) {
							const d2 = {
								label: e.label,
								field: e.label,
							};
							tableHeaders.push(d2);
							tableLabels.push(e);
						}
					});
				const datesArr = [];
				dates &&
					dates.map((nDates, idx) => {
						return nDates.forEach((e) => {
							datesArr.push(e);
						});
					});

				// console.log('tableHeaders', tableHeaders);
				const headers = tableLabels && tableLabels.map((obj) => obj.label);

				const headersAndData = {};
				tableLabels &&
					tableLabels.forEach(
						({ label, data }) => (headersAndData[label] = data)
					);

				const format = datesArr.map((date, dIndex) => {
					let rowData = { date };
					// loop headers and assign value base on dIndex
					headers.forEach((h) => {
						// get current header value
						const value = headersAndData[h][dIndex];
						rowData[h] = value;
					});
					return rowData;
				});
				// console.log('format', format);
				setRowsDataCsv({
					columns: tableHeaders,
					rows: format ? format : [],
				});
				// console.log('data1', data);
			} else if (filterSales || !filterSales) {
				const data = [];
				let filterD = 'Sales';
				if (filterSales) {
					filterD = filterSales;
				}

				const allData =
					currentData &&
					currentData[filterD].map((e, i) => {
						if (e.labels) {
							dates.push(e.labels);
							tableLabels.push({ label: 'Dates', data: e.labels });
						}
						if (e.label) {
							const d2 = {
								label: e.label,
								field: e.label,
							};
							tableHeaders.push(d2);
							tableLabels.push(e);
						}
					});

				const datesArr = [];
				dates &&
					dates.map((nDates, idx) => {
						return nDates.forEach((e) => {
							datesArr.push(e);
						});
					});

				// console.log('tableHeaders', tableHeaders);
				const headers = tableLabels && tableLabels.map((obj) => obj.label);

				const headersAndData = {};
				tableLabels &&
					tableLabels.forEach(
						({ label, data }) => (headersAndData[label] = data)
					);

				const format = datesArr.map((date, dIndex) => {
					let rowData = { date };
					// loop headers and assign value base on dIndex
					headers.forEach((h) => {
						// get current header value
						const value = headersAndData[h][dIndex];
						rowData[h] = value;
					});
					return rowData;
				});
				// console.log('format', format);
				setRowsDataCsv({
					columns: tableHeaders,
					rows: format ? format : [],
				});
			}
		}
	}, [rowsData, salesSku]);

	// console.log('metricFilter', metricFilter);
	// console.log('metricData', metricData);
	// console.log('salesData', salesData);
	// console.log('channels', channels);
	// console.log('currentData', currentData);

	// console.log('rowsD ata', rowsData);

	return (
		<div>
			<h5 className='fw-bold text-mute'> Metric Table</h5>
			<div
				style={{
					height: height ? height : '370px',
					overflowY: 'scroll',
					overflowX: 'hidden',
				}}>
				<MDBDataTable
					data={rowsDataCsv}
					bordered
					noBottomColumns
					small
					responsive
					hover
					paging={false}
					searching={false}
				/>
			</div>

			{rowsDataCsv && rowsDataCsv.rows && (
				<div className='text-white'>
					<CSVLink
						className='badge rounded-pill bg-primary'
						data={rowsDataCsv.rows && rowsDataCsv.rows}
						filename={`dashboard${csvDate}.csv`}
						target='_blank'>
						Download as CSV
					</CSVLink>
				</div>
			)}
		</div>
	);
};

export default SalesTableView;
